module.exports = __webpack_public_path__ + "img/forecast_ru.be5b72da.png";